import {
  AdditionalActionsContainer,
  CategoriesContainer,
  CategoryCard,
  CategoryCardLink,
  CategoryCardsContainer,
  CategoryName,
  ComponentsDescription,
  SearchBarContainer,
} from "./CategoriesStyles";
import {
  TOP_LEVEL_CATEGORIES,
  TopLevelCategory,
} from "../../../utils/categories";
import Icon from "../../common/Icon";
import {
  useCreateSearchLink,
  useUpdateSearch,
} from "../../../utils/hooks/partSearch";
import React from "react";
import { Category } from "../../../reducers/models/categories";
import SearchBar from "../SearchBar";
import AdminPanel from "../AdminPanel";
import useDownloadInStockPartsList from "../../../utils/hooks/inventory/inStockPartsList";
import { FakeLink } from "../../../constants/Styles";

export default function Categories({
  description,
  smallCards,
  doNotRedirect,
}: {
  categories: Category[];
  description: string;
  smallCards?: boolean;
  doNotRedirect?: boolean;
}) {
  const createSearchLink = useCreateSearchLink();
  const updateSearch = useUpdateSearch();
  const downloadInStockParts = useDownloadInStockPartsList();

  const getSearchOptions = (category: TopLevelCategory) => {
    return { updateSearchParameters: { categoryIds: [category.id] } };
  };

  return (
    <CategoriesContainer>
      <ComponentsDescription>{description}</ComponentsDescription>
      <SearchBarContainer>
        <SearchBar placeholder={"Search by text or select category"} />
        <AdminPanel />
      </SearchBarContainer>
      <CategoryCardsContainer $smallCard={smallCards || false}>
        {TOP_LEVEL_CATEGORIES.map((category) => {
          const searchOptions = getSearchOptions(category);
          const cardContents = (
            <>
              <Icon
                src={category.svgFileName}
                alt={category.name}
                iconDimension={smallCards ? 66 : 100}
              />
              <CategoryName $smallCard={smallCards || false}>
                {category.name}
              </CategoryName>
            </>
          );
          if (doNotRedirect) {
            return (
              <CategoryCard
                key={category.name}
                onClick={() => updateSearch(searchOptions)}
                $smallCard={smallCards || false}
              >
                {cardContents}
              </CategoryCard>
            );
          } else {
            return (
              <CategoryCardLink
                key={category.name}
                href={createSearchLink(searchOptions)}
                $smallCard={smallCards || false}
              >
                {cardContents}
              </CategoryCardLink>
            );
          }
        })}
      </CategoryCardsContainer>
      <AdditionalActionsContainer>
        <FakeLink onClick={() => void downloadInStockParts()}>
          Download list of in stock parts
        </FakeLink>
      </AdditionalActionsContainer>
    </CategoriesContainer>
  );
}
